export const getUser = (state) => {
  return state.currentAuth.user
}


export const getToken = (state) => {
  return state.currentAuth.token
}
